// ...existing code...
import React from "react";
import styled from "styled-components";

const NavBar = () => {
  return (
    <Wrapper>
      <NavSurface>
        <BarContent>
          <Logo>
            <span role="img" aria-label="quiz">
              🧠
            </span>
          </Logo>
          <Title>Quiz App</Title>
        </BarContent>
      </NavSurface>
    </Wrapper>
  );
};

export default NavBar;

const Wrapper = styled.nav`
  display: flex;
  justify-content: center;
  background: var(--bg-app);
  padding: 1rem 1rem 0.5rem 1rem;
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  min-width: 0;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(30, 60, 114, 0.08);
  overflow-x: auto;
  box-sizing: border-box;
  backdrop-filter: blur(4px);

  @media (max-width: 600px) {
    padding: 0.85rem 1.25rem;
  }
`;

const Logo = styled.div`
  font-size: 2rem;
`;

const Title = styled.h2`
  color: #fff;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  letter-spacing: 2px;
  margin: 0;
  font-size: 1.5rem;
`;

const BarContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1100px;
  gap: 1rem;
`;

const NavSurface = styled.div`
  width: 100%;
  max-width: 820px;
  background: linear-gradient(
    135deg,
    rgba(30, 60, 114, 0.92),
    rgba(42, 82, 152, 0.94)
  );
  border-radius: 18px;
  padding: 0.75rem 1rem;
  box-shadow: 0 16px 36px rgba(12, 24, 60, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(8px);
`;
